
//   state: {
//     cartState: [],
//     filterState: false,
//   },

//   collectionsProductGraphId(graphId) {
//     let graphqlId = decodeURIComponent(escape(window.atob(graphId)));
//     let decodedId = Number(graphqlId.slice(22));
//     return decodedId;
//   },

//   parseGraphId(graphId) {
//     let graphqlId = decodeURIComponent(escape(window.atob(graphId)));
//     let decodedId = Number(graphqlId.slice(29));
//     return decodedId;
//   },
//   async getCart() {
//     try {
//       const { data } = await axios.get("/cart.js");
//       this.state.cartState.unshift(data);
//     } catch (error) {
//       console.log("Error with getCart() from app.js: ", error);
//     }
//   },

//   increaseQty(productId, currentQty) {
//     let addOneToQty = currentQty + 1;
//     let cartUpdateData = { updates: {} };
//     cartUpdateData.updates[productId] = addOneToQty;
//     ajaxCartFn(cartUpdateData);
//   },

//   decreaseQty(productId, currentQty) {
//     let minusOneToQty = currentQty - 1;
//     let cartUpdateData = { updates: {} };
//     cartUpdateData.updates[productId] = minusOneToQty;
//     ajaxCartFn(cartUpdateData);
//   },
//   removeItem(productId) {
//     let cartUpdateData = { updates: {} };
//     cartUpdateData.updates[productId] = 0;
//     ajaxCartFn(cartUpdateData);
//   },
// });

class CartAPI {
  static async getCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) {
      throw new Error(`HTTP error getting cart! status: ${response.status}`);
    }
    const text = await response.text();
    // Handle empty response from Shopify which can happen.
    return text ? JSON.parse(text) : { items: [], total_price: 0, item_count: 0 };
  }

  static async changeItemQuantity(key, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    
    // Try to parse the response regardless of status, as Shopify may return error info in JSON body
    const responseJson = await response.json().catch(() => ({}));
    
    if (!response.ok) {
      throw new Error(responseJson.description || responseJson.message || `Failed to change item quantity.`);
    }
    
    return responseJson;
  }

  static async updateCart(updates) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
    
    const responseJson = await response.json().catch(() => ({}));
    
    if (!response.ok) {
      throw new Error(responseJson.description || responseJson.message || `Failed to update cart.`);
    }
    
    return responseJson;
  }

  static async addItem(id, quantity = 1) {
    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: quantity }] })
    });

    const responseJson = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new Error(responseJson.description || responseJson.message || `Failed to add item to cart.`);
    }

    return responseJson;
  }

  static async addItems(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });

    const responseJson = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(responseJson.description || responseJson.message || `Failed to add items to cart.`);
    }

    return responseJson;
  }
}

// Make CartAPI globally accessible
window.CartAPI = CartAPI;

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  
  // Return "FREE" for zero prices
  if (cents === 0 || cents === '0') {
    return 'FREE';
  }
  
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = (format || '${{amount}}');

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    let parts = number.split('.');
    let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    let cents = parts[1] ? (decimal + parts[1]) : '';

    // Remove ".00" for whole dollar amounts
    if (cents === decimal + '00') {
      cents = '';
    }

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

class Minicart {
  constructor() {
    this.container = document.getElementById('minicart');
    if (!this.container) return;

    this.overlay = document.getElementById('minicart-overlay');
    this.closeButton = this.container.querySelector('.minicart__close');
    this.itemsContainer = this.container.querySelector('#minicart-items');
    this.loader = this.container.querySelector('.minicart-loader');
    this.subtotalPriceEl = this.container.querySelector('.subtotal-price');
    this.shippingProgress = this.container.querySelector('.minicart-shipping-progress');
    this.checkoutButton = this.container.querySelector('.minicart__checkout-button');

    this.initListeners();
    this.initUpsellCarousel();
    
    // Pre-load cart content on page load without showing loader
    this.render(false);
  }

  initListeners() {
    this.closeButton.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());

    document.addEventListener('cart:add', (e) => {
      this.open();
      this.render();
    });
    
    document.body.addEventListener('click', (evt) => {
      if (evt.target.closest('a[href="#minicart"], a[href*="/cart/add"]')) {
        evt.preventDefault();
        this.open();
      }
    });

    this.itemsContainer.addEventListener('click', (e) => {
      const item = e.target.closest('.minicart-item');
      if (!item) return;

      if (e.target.closest('.quantity-minus')) {
        // Don't allow decreasing quantity for gift items
        const isGiftItem = item.querySelector('.minicart-item__gift-message');
        if (isGiftItem) return;

        const key = item.dataset.key;
        const currentQuantity = parseInt(item.dataset.quantity);
        this.updateQuantity(key, currentQuantity - 1);
      }
      if (e.target.closest('.quantity-plus')) {
        // Don't allow increasing quantity for gift items
        const isGiftItem = item.querySelector('.minicart-item__gift-message');
        if (isGiftItem) return;

        const key = item.dataset.key;
        const currentQuantity = parseInt(item.dataset.quantity);
        this.updateQuantity(key, currentQuantity + 1);
      }
      if (e.target.closest('.minicart-item__remove')) {
        const key = item.dataset.key;
        this.updateQuantity(key, 0);
      }
    });

    const upsellForms = this.container.querySelectorAll('.upsell-add-form');
    upsellForms.forEach(form => {
        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            // Get the product card to access product ID
            const productCard = form.closest('.upsell-product-card');
            const productId = productCard ? parseInt(productCard.dataset.productId) : null;
            const variantId = form.querySelector('input[name="id"]').value;

            // Get GWP campaigns configuration
            let gwpCampaigns = [];
            try {
                const gwpCampaignsData = this.container.dataset.gwpCampaigns;
                if (gwpCampaignsData) {
                    gwpCampaigns = JSON.parse(gwpCampaignsData);
                }
            } catch (error) {
                console.error('Error parsing GWP campaigns:', error);
            }

            try {
                // Prepare items array
                const items = [{ id: variantId, quantity: 1 }];

                // Get current cart to check prices and existing items
                const currentCart = await CartAPI.getCart();
                const currentCartTotal = currentCart.total_price; // in cents

                // Get the price of the variant being added
                const variantPrice = parseInt(productCard.dataset.variantPrice) || 0;

                // Calculate projected cart total AFTER adding this item
                const projectedCartTotal = currentCartTotal + variantPrice;

                // Check all GWP campaigns
                if (gwpCampaigns && gwpCampaigns.length > 0) {
                    for (const campaign of gwpCampaigns) {
                        // Check if required product exists in cart OR is being added right now
                        const requiredProductInCart = currentCart.items.find(item =>
                            item.product_id === campaign.requiredProductId
                        );
                        const requiredProductBeingAdded = campaign.requiredProductId === productId;
                        const requiredProductExists = requiredProductInCart || requiredProductBeingAdded;

                        // Check if required product exists (in cart or being added)
                        if (requiredProductExists && campaign.freeVariantId) {
                            console.log(`[GWP Upsell] Campaign #${campaign.campaignId}: Required product found ${requiredProductBeingAdded ? '(being added now)' : '(already in cart)'}`);

                            // Check if minimum price requirement will be met AFTER adding the main product
                            if (projectedCartTotal >= campaign.minimumPriceCents) {
                                // Check if free product is already in cart or already queued
                                const freeProductInCart = currentCart.items.find(item =>
                                    item.variant_id === campaign.freeVariantId
                                );
                                const freeProductAlreadyQueued = items.some(item =>
                                    item.id === campaign.freeVariantId
                                );

                                if (!freeProductInCart && !freeProductAlreadyQueued) {
                                    items.push({
                                        id: campaign.freeVariantId,
                                        quantity: 1,
                                        properties: {
                                            gift: true,
                                            _gwp_campaign_id: campaign.campaignId,
                                            _gwp_required_product_id: campaign.requiredProductId
                                        }
                                    });
                                    console.log(`[GWP Upsell] Campaign #${campaign.campaignId}: Adding free product from minicart upsell`);
                                } else {
                                    console.log(`[GWP Upsell] Campaign #${campaign.campaignId}: Free product already ${freeProductInCart ? 'in cart' : 'queued'}, skipping`);
                                }
                            } else {
                                console.log(`[GWP Upsell] Campaign #${campaign.campaignId}: Minimum price not met from minicart. Required: $${campaign.minimumPriceCents / 100}, Projected: $${projectedCartTotal / 100}`);
                            }
                        } else {
                            console.log(`[GWP Upsell] Campaign #${campaign.campaignId}: Required product not found in cart`);
                        }
                    }
                }

                // Check for price-only GWP campaigns
                let gwpPriceOnlyCampaigns = [];
                try {
                    const gwpPriceOnlyCampaignsData = this.container.dataset.gwpPriceOnlyCampaigns;
                    if (gwpPriceOnlyCampaignsData) {
                        gwpPriceOnlyCampaigns = JSON.parse(gwpPriceOnlyCampaignsData);
                        console.log('[GWP Upsell Price-Only] Parsed price-only campaigns:', gwpPriceOnlyCampaigns);
                    }
                } catch (error) {
                    console.error('[GWP Upsell Price-Only] Error parsing price-only campaigns:', error);
                }

                if (gwpPriceOnlyCampaigns && gwpPriceOnlyCampaigns.length > 0) {
                    console.log(`[GWP Upsell Price-Only] Checking ${gwpPriceOnlyCampaigns.length} price-only campaigns...`);

                    for (const campaign of gwpPriceOnlyCampaigns) {
                        console.log(`[GWP Upsell Price-Only] Campaign #${campaign.campaignId}:`, campaign);

                        // Validate campaign data
                        if (!campaign.freeVariantId || !campaign.minimumPriceCents || campaign.minimumPriceCents <= 0) {
                            console.warn(`[GWP Upsell Price-Only] Campaign #${campaign.campaignId}: Invalid campaign data`);
                            continue;
                        }

                        // Check if minimum price requirement will be met AFTER adding the main product
                        if (projectedCartTotal >= campaign.minimumPriceCents) {
                            console.log(`[GWP Upsell Price-Only] Campaign #${campaign.campaignId}: Price threshold met ($${projectedCartTotal / 100} >= $${campaign.minimumPriceCents / 100})`);

                            // Check if free product is already in cart or already queued
                            const freeProductInCart = currentCart.items.find(item =>
                                item.variant_id === campaign.freeVariantId
                            );
                            const freeProductAlreadyQueued = items.some(item =>
                                item.id === campaign.freeVariantId
                            );

                            if (!freeProductInCart && !freeProductAlreadyQueued) {
                                items.push({
                                    id: campaign.freeVariantId,
                                    quantity: 1,
                                    properties: {
                                        gift: true,
                                        _gwp_price_only_campaign_id: campaign.campaignId,
                                        _gwp_type: 'price_only'
                                    }
                                });
                                console.log(`[GWP Upsell Price-Only] Campaign #${campaign.campaignId}: Adding free product from minicart upsell`);
                            } else {
                                console.log(`[GWP Upsell Price-Only] Campaign #${campaign.campaignId}: Free product already ${freeProductInCart ? 'in cart' : 'queued'}, skipping`);
                            }
                        } else {
                            console.log(`[GWP Upsell Price-Only] Campaign #${campaign.campaignId}: Minimum price not met. Required: $${campaign.minimumPriceCents / 100}, Projected: $${projectedCartTotal / 100}`);
                        }
                    }
                }

                // Add items to cart (from both product-based and price-only campaigns)
                if (items.length === 1) {
                    // Only main product, use simple add
                    await CartAPI.addItem(variantId);
                } else {
                    // Multiple items (main + GWP gifts), use batch add
                    const response = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ items: items })
                    });

                    if (!response.ok) {
                        throw new Error('Failed to add items to cart');
                    }
                }

                await this.render(); // This will update cart count
                document.dispatchEvent(new CustomEvent('cart:add'));
            } catch (error) {
                console.error('Error adding to cart:', error);
                this.showErrorMessage('Unable to add item to cart. Please try again.');
            }
        });
    });
  }

  initUpsellCarousel() {
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper library is not loaded.');
      return;
    }

    const swiperContainer = this.container.querySelector('.minicart-upsell-swiper');
    if (swiperContainer) {
      new Swiper(swiperContainer, {
        loop: true,
        slidesPerView: 1.7,
        spaceBetween: 2,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }
  }

  open() {
    this.container.classList.add('is-open');
    this.overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.container.classList.remove('is-open');
    this.overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  setLoading(isLoading) {
    this.loader.style.display = isLoading ? 'flex' : 'none';
  }

  /**
   * Find paired gift item that should be removed with the main item.
   * Generic logic: If main item has an automatic discount (e.g., BXGY), find the paired free item.
   */
  findPairedGiftItem(mainItem, allItems) {
    // Check if main item has any automatic discount allocations
    if (!mainItem.line_level_discount_allocations || mainItem.line_level_discount_allocations.length === 0) {
      return null;
    }

    // Look for automatic discounts (like BXGY - Buy X Get Y)
    const automaticDiscount = mainItem.line_level_discount_allocations.find(
      allocation => allocation.discount_application?.type === 'automatic'
    );

    if (!automaticDiscount || !automaticDiscount.discount_application?.key) {
      return null;
    }

    // Get the discount key from main item
    const discountKey = automaticDiscount.discount_application.key;

    // Find any FREE item (gift) with the same discount key
    // This will work with any product, not just mirrors
    const pairedGiftItem = allItems.find(item =>
      item.key !== mainItem.key && // Don't match self
      (item.final_line_price === 0 || item.final_price === 0) && // Must be free
      item.line_level_discount_allocations?.some(
        allocation => allocation.discount_application?.key === discountKey
      )
    );

    return pairedGiftItem ? pairedGiftItem.key : null;
  }

  showErrorMessage(message) {
    // Create or update error message element
    let errorEl = this.container.querySelector('.minicart-error-message');
    if (!errorEl) {
      errorEl = document.createElement('div');
      errorEl.className = 'minicart-error-message';
      errorEl.style.cssText = `
        position: absolute;
        top: 60px;
        left: 50%;
        transform: translateX(-50%);
        background: #f44336;
        color: white;
        padding: 10px 20px;
        border-radius: 4px;
        z-index: 1000;
        font-size: 14px;
        font-family: var(--secondary-font-family);
      `;
      this.container.appendChild(errorEl);
    }
    
    errorEl.textContent = message;
    errorEl.style.display = 'block';
    
    // Auto-hide after 3 seconds
    setTimeout(() => {
      errorEl.style.display = 'none';
    }, 3000);
  }

  async updateQuantity(key, quantity) {
    this.setLoading(true);

    try {
      // If removing an item (quantity = 0), check for paired gift
      if (quantity === 0) {
        const currentCart = await CartAPI.getCart();
        const itemBeingRemoved = currentCart.items.find(item => item.key === key);

        if (!itemBeingRemoved) {
          console.warn('Item not found in cart:', key);
          await this.render();
          return;
        }

        const pairedGiftKey = this.findPairedGiftItem(itemBeingRemoved, currentCart.items);

        let cartAfterRemoval;
        if (pairedGiftKey) {
          // Remove both items in a single API call
          const updates = {};
          updates[key] = 0;
          updates[pairedGiftKey] = 0;

          cartAfterRemoval = await CartAPI.updateCart(updates);
          console.log('Removed both paired items in single call');
        } else {
          // Just remove the single item
          cartAfterRemoval = await CartAPI.changeItemQuantity(key, 0);
        }

        // Removing a non-gift item may drop the cart below a GWP threshold.
        // Reconcile (remove orphaned gifts) first, then re-check whether any
        // other campaign still qualifies and add if so.
        const afterReconcile = await this.reconcileGWPProducts(cartAfterRemoval);
        await this.checkAndAddGWPProducts(afterReconcile);
      } else {
        // Normal quantity update - returns updated cart
        const updatedCart = await CartAPI.changeItemQuantity(key, quantity);
        console.log('[GWP] Quantity updated, checking GWP with updated cart:', {
          total: updatedCart.total_price / 100,
          itemCount: updatedCart.items?.length
        });

        // After quantity update: reconcile removals first, then add. Order
        // matters — adding before removing could keep an unqualified gift.
        const afterReconcile = await this.reconcileGWPProducts(updatedCart);
        await this.checkAndAddGWPProducts(afterReconcile);
      }

      await this.render();
    } catch (error) {
      console.error('Error updating cart:', error);
      this.showErrorMessage('Unable to update cart. Please try again.');
      await this.render();
    } finally {
      this.setLoading(false);
    }
  }

  // Remove free gifts from the cart whose campaign no longer qualifies —
  // either the cart's non-gift subtotal dropped below the campaign's
  // minimumPriceCents, or (for product-based campaigns) the required product
  // is no longer in the cart. Threshold is read from each campaign's
  // minimumPriceCents, not a hardcoded number.
  //
  // Returns the latest cart object (post-removal) so callers can chain into
  // checkAndAddGWPProducts without a stale cart.
  async reconcileGWPProducts(cartData = null) {
    // Parse both campaign sets the same way checkAndAddGWPProducts does.
    let gwpCampaigns = [];
    let gwpPriceOnlyCampaigns = [];
    try {
      const raw = this.container.dataset.gwpCampaigns;
      if (raw) gwpCampaigns = JSON.parse(raw);
    } catch (err) {
      console.error('[GWP Reconcile] Error parsing product campaigns:', err);
    }
    try {
      const rawPriceOnly = this.container.dataset.gwpPriceOnlyCampaigns;
      if (rawPriceOnly) gwpPriceOnlyCampaigns = JSON.parse(rawPriceOnly);
    } catch (err) {
      console.error('[GWP Reconcile] Error parsing price-only campaigns:', err);
    }

    const hasAny =
      (gwpCampaigns && gwpCampaigns.length > 0) ||
      (gwpPriceOnlyCampaigns && gwpPriceOnlyCampaigns.length > 0);
    if (!hasAny) return cartData || await CartAPI.getCart();

    try {
      const currentCart = cartData || await CartAPI.getCart();

      // Collect every variant id that is currently configured as a free gift,
      // so we can exclude those lines when computing the qualifying subtotal.
      // Using original_line_price further protects against any line-level
      // discount that may have zeroed a gift line out.
      const freeVariantIds = new Set([
        ...gwpCampaigns.map(c => c.freeVariantId).filter(Boolean),
        ...gwpPriceOnlyCampaigns.map(c => c.freeVariantId).filter(Boolean)
      ]);

      const nonGiftSubtotal = (currentCart.items || [])
        .filter(item => !freeVariantIds.has(item.variant_id))
        .reduce((sum, item) => {
          const linePrice = (item.original_line_price !== undefined)
            ? item.original_line_price
            : item.line_price;
          return sum + linePrice;
        }, 0);

      console.log('[GWP Reconcile] Non-gift subtotal:', nonGiftSubtotal / 100);

      // Build a removal map keyed by line key — using one /cart/update.js
      // call avoids racy partial states between multiple /cart/change.js POSTs.
      const updates = {};

      // Product-based campaigns: remove gift if either (a) required product is
      // no longer in cart, or (b) qualifying subtotal is below the minimum.
      for (const campaign of gwpCampaigns) {
        if (!campaign || !campaign.freeVariantId) continue;
        const giftLine = (currentCart.items || []).find(item =>
          item.variant_id === campaign.freeVariantId
        );
        if (!giftLine) continue;

        const requiredProductStillThere = (currentCart.items || []).some(item =>
          item.product_id === campaign.requiredProductId &&
          item.variant_id !== campaign.freeVariantId
        );
        const meetsMinimum = nonGiftSubtotal >= (campaign.minimumPriceCents || 0);

        if (!requiredProductStillThere || !meetsMinimum) {
          console.log(`[GWP Reconcile] Removing gift for Campaign #${campaign.campaignId}`, {
            requiredProductStillThere,
            meetsMinimum,
            subtotal: nonGiftSubtotal / 100,
            min: (campaign.minimumPriceCents || 0) / 100
          });
          updates[giftLine.key] = 0;
        }
      }

      // Price-only campaigns: remove gift if non-gift subtotal dropped below
      // the configured minimum.
      for (const campaign of gwpPriceOnlyCampaigns) {
        if (!campaign || !campaign.freeVariantId) continue;
        if (!campaign.minimumPriceCents || campaign.minimumPriceCents <= 0) continue;
        const giftLine = (currentCart.items || []).find(item =>
          item.variant_id === campaign.freeVariantId
        );
        if (!giftLine) continue;

        if (nonGiftSubtotal < campaign.minimumPriceCents) {
          console.log(`[GWP Reconcile] Removing price-only gift for Campaign #${campaign.campaignId}`, {
            subtotal: nonGiftSubtotal / 100,
            min: campaign.minimumPriceCents / 100
          });
          updates[giftLine.key] = 0;
        }
      }

      if (Object.keys(updates).length === 0) {
        return currentCart;
      }

      const afterRemoval = await CartAPI.updateCart(updates);
      console.log('[GWP Reconcile] Removed', Object.keys(updates).length, 'gift line(s)');
      return afterRemoval;
    } catch (error) {
      console.error('[GWP Reconcile] Error:', error);
      return cartData || null;
    }
  }

  async checkAndAddGWPProducts(cartData = null) {
    // Get GWP campaigns configuration
    let gwpCampaigns = [];
    try {
      const gwpCampaignsData = this.container.dataset.gwpCampaigns;
      console.log('[GWP] Raw campaigns data attribute:', gwpCampaignsData);
      console.log('[GWP] Container element:', this.container);
      console.log('[GWP] All data attributes:', this.container.dataset);

      if (gwpCampaignsData) {
        gwpCampaigns = JSON.parse(gwpCampaignsData);
        console.log('[GWP] Parsed campaigns:', gwpCampaigns);
      } else {
        console.warn('[GWP] gwpCampaignsData is empty or undefined');
      }
    } catch (error) {
      console.error('[GWP] Error parsing campaigns:', error);
      return;
    }

    if (!gwpCampaigns || gwpCampaigns.length === 0) {
      console.log('[GWP] No product-based campaigns configured, checking price-only campaigns...');
    }

    try {
      // Use provided cart data or fetch current cart state
      const currentCart = cartData || await CartAPI.getCart();
      const currentCartTotal = currentCart.total_price; // in cents

      console.log('[GWP] Checking GWP after quantity change. Cart state:', {
        total: currentCartTotal / 100,
        totalCents: currentCartTotal,
        cartProvided: !!cartData,
        items: currentCart.items.map(item => ({
          product_id: item.product_id,
          variant_id: item.variant_id,
          title: item.title,
          quantity: item.quantity,
          price: item.price
        }))
      });

      // Collect items to add
      const itemsToAdd = [];

      // Check each product-based GWP campaign
      if (gwpCampaigns && gwpCampaigns.length > 0) {
        console.log('[GWP] Checking', gwpCampaigns.length, 'product-based campaigns...');
        for (const campaign of gwpCampaigns) {
        console.log(`[GWP] Checking Campaign #${campaign.campaignId}:`, campaign);

        // Check if cart contains the required product
        const hasRequiredProduct = currentCart.items.some(item => {
          const matches = item.product_id === campaign.requiredProductId;
          console.log(`[GWP]   Item ${item.product_id} === ${campaign.requiredProductId}? ${matches}`);
          return matches;
        });

        console.log(`[GWP]   Has required product? ${hasRequiredProduct}`);

        if (!hasRequiredProduct) {
          console.log(`[GWP] Campaign #${campaign.campaignId}: Required product not in cart`);
          continue;
        }

        // Check if minimum price requirement is met
        if (currentCartTotal < campaign.minimumPriceCents) {
          console.log(`GWP Campaign #${campaign.campaignId}: Minimum price not met. Required: $${campaign.minimumPriceCents / 100}, Current: $${currentCartTotal / 100}`);
          continue;
        }

        // Check if free product is already in cart or already queued
        const freeProductInCart = currentCart.items.find(item =>
          item.variant_id === campaign.freeVariantId
        );
        const freeProductAlreadyQueued = itemsToAdd.some(item =>
          item.id === campaign.freeVariantId
        );

        console.log(`[GWP]   Free product in cart? ${!!freeProductInCart}, already queued? ${freeProductAlreadyQueued}`);

        if (!freeProductInCart && !freeProductAlreadyQueued) {
          itemsToAdd.push({
            id: campaign.freeVariantId,
            quantity: 1,
            properties: {
              gift: true,
              _gwp_campaign_id: campaign.campaignId,
              _gwp_required_product_id: campaign.requiredProductId
            }
          });
          console.log(`[GWP] Campaign #${campaign.campaignId}: Adding free product after quantity change`);
        } else {
          console.log(`[GWP] Campaign #${campaign.campaignId}: Free product already ${freeProductInCart ? 'in cart' : 'queued'}, skipping`);
        }
        }
      } else {
        console.log('[GWP] No product-based campaigns to check');
      }

      // Check for price-only GWP campaigns
      let gwpPriceOnlyCampaigns = [];
      try {
        const gwpPriceOnlyCampaignsData = this.container.dataset.gwpPriceOnlyCampaigns;
        if (gwpPriceOnlyCampaignsData) {
          gwpPriceOnlyCampaigns = JSON.parse(gwpPriceOnlyCampaignsData);
          console.log('[GWP Price-Only] Parsed price-only campaigns:', gwpPriceOnlyCampaigns);
        }
      } catch (error) {
        console.error('[GWP Price-Only] Error parsing price-only campaigns:', error);
      }

      if (gwpPriceOnlyCampaigns && gwpPriceOnlyCampaigns.length > 0) {
        console.log(`[GWP Price-Only] Checking ${gwpPriceOnlyCampaigns.length} price-only campaigns...`);

        for (const campaign of gwpPriceOnlyCampaigns) {
          console.log(`[GWP Price-Only] Checking Campaign #${campaign.campaignId}:`, campaign);

          // Validate campaign data
          if (!campaign.freeVariantId || !campaign.minimumPriceCents || campaign.minimumPriceCents <= 0) {
            console.warn(`[GWP Price-Only] Campaign #${campaign.campaignId}: Invalid campaign data`);
            continue;
          }

          // Check if minimum price requirement is met
          if (currentCartTotal < campaign.minimumPriceCents) {
            console.log(`[GWP Price-Only] Campaign #${campaign.campaignId}: Minimum price not met. Required: $${campaign.minimumPriceCents / 100}, Current: $${currentCartTotal / 100}`);
            continue;
          }

          console.log(`[GWP Price-Only] Campaign #${campaign.campaignId}: Price threshold met`);

          // Check if free product is already in cart or already queued
          const freeProductInCart = currentCart.items.find(item =>
            item.variant_id === campaign.freeVariantId
          );
          const freeProductAlreadyQueued = itemsToAdd.some(item =>
            item.id === campaign.freeVariantId
          );

          console.log(`[GWP Price-Only]   Free product in cart? ${!!freeProductInCart}, already queued? ${freeProductAlreadyQueued}`);

          if (!freeProductInCart && !freeProductAlreadyQueued) {
            itemsToAdd.push({
              id: campaign.freeVariantId,
              quantity: 1,
              properties: {
                gift: true,
                _gwp_price_only_campaign_id: campaign.campaignId,
                _gwp_type: 'price_only'
              }
            });
            console.log(`[GWP Price-Only] Campaign #${campaign.campaignId}: Adding free product`);
          } else {
            console.log(`[GWP Price-Only] Campaign #${campaign.campaignId}: Free product already ${freeProductInCart ? 'in cart' : 'queued'}, skipping`);
          }
        }
      }

      // Add all qualifying free products (from both product-based and price-only campaigns)
      if (itemsToAdd.length > 0) {
        console.log('[GWP] Items to add:', itemsToAdd);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error('[GWP] Failed to add items. Response:', errorText);
          throw new Error('Failed to add GWP items to cart');
        }

        console.log(`[GWP] Successfully added ${itemsToAdd.length} GWP item(s) to cart`);
      } else {
        console.log('[GWP] No items to add');
      }
    } catch (error) {
      console.error('Error checking/adding GWP products:', error);
    }
  }

  async render(showLoader = true) {
    if (showLoader) {
      this.setLoading(true);
    }
    try {
      const cart = await CartAPI.getCart();
      
      this.renderItems(cart.items);
      this.renderSubtotal(cart.total_price);
      this.updateShippingProgress(cart.total_price);
      this.updateCartCount(cart.item_count);
    } catch (e) {
      console.error(e);
      this.itemsContainer.innerHTML = '<p>There was an error fetching your cart.</p>';
    } finally {
      if (showLoader) {
        this.setLoading(false);
      }
    }
  }

  renderItems(items) {
    this.itemsContainer.innerHTML = '';
    if (items.length === 0) {
      this.itemsContainer.innerHTML = '<p class="empty-minicart">Your bag is empty.</p>';
      this.checkoutButton.style.display = 'none';
      this.itemsContainer.classList.remove('has-items');
      return;
    }
    this.checkoutButton.style.display = 'flex';
    this.itemsContainer.classList.add('has-items');

    // Sort items: gift-with-purchase items should appear last
    const sortedItems = [...items].sort((a, b) => {
      const aIsGiftWithPurchase = this.hasGiftWithPurchaseTag(a);
      const bIsGiftWithPurchase = this.hasGiftWithPurchaseTag(b);
      
      // If both are gift-with-purchase or both are not, maintain original order
      if (aIsGiftWithPurchase === bIsGiftWithPurchase) {
        return 0;
      }
      // If only 'a' is gift-with-purchase, it should come after 'b'
      if (aIsGiftWithPurchase) {
        return 1;
      }
      // If only 'b' is gift-with-purchase, it should come after 'a'
      return -1;
    });

    sortedItems.forEach(item => {
      const itemEl = this.createItemElement(item);
      this.itemsContainer.appendChild(itemEl);
    });
  }

  createItemElement(item) {
    const itemDiv = document.createElement('div');
    itemDiv.classList.add('minicart-item');
    itemDiv.dataset.key = item.key;
    itemDiv.dataset.quantity = item.quantity;

    const price = formatMoney(item.final_line_price, theme.moneyFormat);
    
    // Check for gift items using multiple approaches since product_tags isn't available
    const isGift = this.isGiftItem(item);
    const giftMessage = this.container.dataset.giftMessage || 'a little gift from us to you';

    // Build the quantity selector or gift message
    const quantityOrGiftHtml = isGift ?
      `<span class="minicart-item__gift-message">${giftMessage}</span>

        <div class="minicart-quantity-selector">
           <button disabled class="quantity-minus" style="opacity: 0.2; cursor: default;">-</button>
           <span class="quantity-display">${item.quantity}</span>
           <button disabled class="quantity-plus" style="opacity: 0.2; cursor: default;">+</button>
        </div>
      `
      :
      `
      <div class="minicart-quantity-selector">
         <button class="quantity-minus">-</button>
         <span class="quantity-display">${item.quantity}</span>
         <button class="quantity-plus">+</button>
      </div>
      `;

    itemDiv.innerHTML = `
      <img src="${item.image}" alt="${item.title}" class="minicart-item__image" />
      <div class="minicart-item__details">
        <h3 class="minicart-item__title">${item.product_title}</h3>
        ${item.variant_title ? `<span class="minicart-item__variant">${item.variant_title}</span>` : ''}
        ${!isGift && item.product_type ? `<span class="minicart-item__subtitle">${item.product_type}</span>` : ""}
        ${quantityOrGiftHtml}
      </div>
      <div class="minicart-item__meta">
        <span class="minicart-item__price">${price}</span>
        ${isGift ? '' : '<button class="minicart-item__remove">remove</button>'}
      </div>
    `;
    return itemDiv;
  }

  hasGiftWithPurchaseTag(item) {
    // Check if the item should be sorted to the end (gift products)
    // An item is a gift ONLY if it's currently free
    // This allows items to move between regular and gift status as cart total changes

    const isFree = item.final_line_price === 0 || item.final_price === 0;

    // If item is not free, it's not a gift (even if it has gift property)
    if (!isFree) {
      return false;
    }

    // If item is free, it's a gift (whether from GWP or automatic discounts)
    return true;
  }

  isGiftItem(item) {
    // A gift item must be FREE (final_line_price === 0)
    // This determines whether to show quantity selector or gift message
    //
    // The gift message should dynamically appear/disappear based on:
    // 1. Cart total meeting GWP campaign minimum price threshold
    // 2. Shopify's automatic discount system setting final_line_price to 0
    //
    // When cart total drops below minimum, Shopify removes the discount,
    // final_line_price becomes > 0, and gift message should disappear

    const isFree = item.final_line_price === 0 || item.final_price === 0;

    // If item is not free, it's not a gift (even if it has gift property)
    // This allows the gift message to disappear when cart total drops below minimum
    if (!isFree) {
      return false;
    }

    // If item is free AND has gift property, it's a GWP gift
    if (item.properties && item.properties.gift === true) {
      return true;
    }

    // If item is free without gift property, it's likely an automatic discount gift
    // Still treat it as a gift
    return true;
  }

  renderSubtotal(totalPrice) {
    const price = formatMoney(totalPrice, theme.moneyFormat);
    this.subtotalPriceEl.textContent = price;
  }

  updateShippingProgress(totalPrice) {
    if (!this.shippingProgress) return;
    
    const thresholdInDollars = parseInt(this.shippingProgress.dataset.threshold, 10);
    const thresholdInCents = thresholdInDollars * 100;

    const progressTextEl = this.shippingProgress.querySelector('.progress-text');
    const successTextEl = this.shippingProgress.querySelector('.progress-text-success');
    const progressBar = this.shippingProgress.querySelector('.progress-bar');
    
    if (totalPrice >= thresholdInCents) {
      progressBar.style.width = '100%';
      progressTextEl.style.display = 'none';
      successTextEl.style.display = 'block';
    } else {
      const percentage = (totalPrice / thresholdInCents) * 100;
      const remaining = thresholdInCents - totalPrice;
      const remainingFormatted = formatMoney(remaining, theme.moneyFormat);
      const textTemplate = progressTextEl.dataset.textTemplate;
      
      progressBar.style.width = `${percentage}%`;
      progressTextEl.innerHTML = textTemplate.replace('{amount}', remainingFormatted);
      progressTextEl.style.display = 'block';
      successTextEl.style.display = 'none';
    }
  }

  updateCartCount(itemCount) {
    const cartCountElements = document.querySelectorAll('.cart-count');
    cartCountElements.forEach(element => {
      element.textContent = `(${itemCount})`;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Minicart();
});

const toggleTiniCart = {
  openCart() {
    tiniCartState.hidden = !tiniCartState.hidden;
  },
};

/*

 (() => {
  const passwordInput = document.querySelector('#password-input');
  if (!passwordInput) {
    console.error('Password input not found.');
    return;
  }

  passwordInput.value = 'eklogu';

  // Trigger an input event in case Shopify listens for changes
  const event = new Event('input', { bubbles: true });
  passwordInput.dispatchEvent(event);

  // Find the closest form and submit it
  const form = passwordInput.closest('form');
  if (!form) {
    console.error('Form not found.');
    return;
  }

  form.submit();
})();

*/